export { default as defaulDictionary } from '../locales/ru.json.js';

var defaultLocaleCtx = {
  locale: 'ru-RU',
  lang: 'ru',
  useSuspense: false
};
var NOVA_I18N_KEY = '__nova_i18n__';
var NOVA_ADDITIONAL_LANGS = new Set(['en', 'ru', 'es']);
var DEFAULT_NAMESPACE = 'nova-translations';
var NEXT_DATA_SELECTOR = '#__NEXT_DATA__';
var INITIALIZED = 'initialized';
var LOADED = 'loaded';
var LANG_CHANGED = 'languageChanged';

export { DEFAULT_NAMESPACE, INITIALIZED, LANG_CHANGED, LOADED, NEXT_DATA_SELECTOR, NOVA_ADDITIONAL_LANGS, NOVA_I18N_KEY, defaultLocaleCtx };
